import { render, staticRenderFns } from "./SearchResultItem.vue?vue&type=template&id=41308e2f&scoped=true&"
import script from "./SearchResultItem.vue?vue&type=script&lang=ts&"
export * from "./SearchResultItem.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultItem.vue?vue&type=style&index=0&id=41308e2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41308e2f",
  null
  
)

export default component.exports